module.exports = __webpack_public_path__ + "static/media/bubblewoods.3bb79369.jpg";